// MATERIAL
import { ButtonBase } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Button = styled(ButtonBase)({
  height: 38,
  width: 38,
  borderRadius: "50%",
});
